// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__7fa36","modal":"Modal_modal__a2GFU","slide-down":"Modal_slide-down__I12u6"};